<style scoped>
  .btn-group {
    padding-left: 20px;
  }
</style>
<template>
  <div>
    <h3 class="title">角色管理列表</h3>
    <div class="margin-bottom-10">
      <label style="margin-right: 10px;">关键字：</label>
      <Input v-model="d_CondList.Key" placeholder="功能还未启用" style="display: inline-block;width:200px;margin-right: 10px;"/>
      <Button type="primary" @click="search()">查询</Button>
      <Button type="primary" @click="to_add()" style="float: right;">新增</Button>
    </div>
    <div>
      <Table :columns="d_columns" border :data="d_data"></Table>
      <div class="margin-top-20">
        <Page :total="d_total" show-sizer show-total @on-change="flip" @on-page-size-change="change_size" class="pull-right"></Page>
        <div class="clear-both"></div>
      </div>
    </div>
    <Modal
      v-model="d_modal_add"
      :title="d_modal_title"
      footer-hide
      >
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="80">
        <FormItem label="角色主键" prop="Code" v-if="d_modal_type=='add'">
          <Input v-model="add_params.Code" placeholder="请输入角色主键"></Input>
        </FormItem>
        <FormItem label="角色主键" prop="Code" v-else>
          <Input v-model="add_params.Code" placeholder="请输入角色主键" disabled></Input>
        </FormItem>
        <FormItem label="角色名称" prop="Name">
          <Input v-model="add_params.Name" placeholder="请输入角色名称"></Input>
        </FormItem>
        <FormItem label="备注" prop="Notes">
          <Input v-model="add_params.Notes" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      v-model="d_modal_set"
      title="设置权限"
      width="700px"
    >
      <div style="max-height: 400px;overflow: auto;border: solid 1px #f5f5f5;padding-left:10px;">
        <Tree :data="d_tree.authList" show-checkbox ></Tree>
      </div>
      <div slot="footer">
        <Button type="primary" @click="set_role_auth">保存</Button>
        <Button @click="set_modal_cancel" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import apiRole from '@/api/role.js';
  export default {
    name:'roleManage_page',
    data() {
      return {
        d_total: 0,
        d_page: 1,
        d_page_size: 10,
        d_modal_add: false,
        d_modal_title: '',
        d_CondList:[ //筛选条件
          {
            Key:''
          }
        ],
        d_columns: [
          {
            title: '角色主键',
            key: 'Code'
          },
          {
            title: '角色名称',
            key: 'Name'
          },
          {
            title: '备注',
            key: 'Notes'
          },
          {
            title: '管理数量',
            key: 'UserCount'
          },
          {
            title: "操作",
            key: "do",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_edit(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条数据吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row)
                          }
                        });
                      }
                    }
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_openSet(params.row)
                      }
                    }
                  },
                  "设置权限"
                )
              ])
            }
          }
        ],
        d_data: [],
        params: {},
        add_params:{},//编辑需要传的参数
        ruleValidate: {
          Code: [
            {required: true, message: '主键名字不能为空', trigger: 'blur'}
          ],
          Name: [
            {required: true, message: 'name不能为空', trigger: 'blur'}
          ],
        },
        d_modal_type: '', // 如果是添加打开的modal，就传add，如果是编辑打开的modal，就传edit，因为是同一个modal
        d_tree:{
          authList:[],
          roleCode:''
        },
        d_test_authList:[],
        d_modal_set:false,

      };
    },
    methods: {
      search() {
        this.params.PageIndex=1;
        this.pull_data();
      },
      flip(page) { //翻页条件，每页多少条，多少页
        this.params.PageIndex = page;
        this.params.PageSize = this.d_page_size;
        this.pull_data();
      },
      change_size(size) { //改变limit 每页显示多少条
        this.params.PageSize = size;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        apiRole.getRoleList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            _this.d_total = requestResult.Total;  // 数据数量统计
            _this.d_data = requestResult.RowsList; //数据列表开始
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_add(){
        this.d_modal_add = true;
        this.d_modal_type = 'add';
        this.d_modal_title = '添加角色';
        this.add_params.Code = '';
        this.add_params.Name = '';
        this.add_params.Notes = '';
      },
      to_edit(row){
        this.d_modal_type = 'edit';
        this.d_modal_title = '添加角色';
        this.add_params.Code = row.Code;
        this.add_params.Name = row.Name;
        this.add_params.Notes = row.Notes;
        this.$refs['formValidate'].validate((valid)=> {});//重新验证，不然会有提示
        this.d_modal_add = true;
      },
      to_delete(row){
        apiRole.delRole(row.Code).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('删除成功');
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_openSet(row){
        this.d_modal_set = true;
        this.d_tree.authList=[];
        this.d_tree.roleCode = row.Code;
        apiRole.getRoleAuthAndSysAuthList(row.Code).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let dataList = _data.data.Data;  // 你只需要按menuID分组，如果里面有operateCode，就把组内的操作加载出来
            let menuList = JSON.parse(JSON.stringify(_data.data.Data));
            menuList = this.no_repeat_json(menuList);
            for (let x = 0; x < menuList.length; x++) {
                if(menuList[x].OperateCode != null){
                  let authList = {};
                  authList.title = menuList[x].MenuName;
                  authList.expand = false;
                  authList.children = [];
                  for (let y = 0; y < dataList.length; y++) {
                    if(menuList[x].MenuID == dataList[y].MenuID && dataList[y].OperateCode != null){
                      let currMenu = {};
                      currMenu.title = dataList[y].OperateName;
                      currMenu.expand = false;
                      currMenu.checked = dataList[y].HasAuth==1 ? true:false;
                      currMenu.operateCode = dataList[y].OperateCode;
                      authList.children.push(currMenu);
                    }
                  }
                  this.d_tree.authList.push(authList);
                }
            }
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      set_modal_cancel(){ this.d_modal_set = false },
      set_role_auth(){
        let roleCode = this.d_tree.roleCode;
        let operateCodeList = [];
        for (let x = 0; x < this.d_tree.authList.length; x++) { //此处的重组数据有问题，如果有三层菜单，四层菜单就不好弄
          if(this.d_tree.authList[x].children){
            for (let y = 0; y < this.d_tree.authList[x].children.length; y++) {
              if(this.d_tree.authList[x].children[y].checked){
                operateCodeList.push(this.d_tree.authList[x].children[y].operateCode)
              }
            }
          }
        }
        apiRole.setRoleAuth(roleCode,operateCodeList).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('设置成功');
            this.d_modal_set = false;
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      add_modal_cancel(){
        this.d_modal_add = false;
      },
      edit_confirm (name) {
        let _this = this;
        this.$refs[name].validate((valid) => {
          if (valid) {
            if(_this.d_modal_type=='add'){
              apiRole.addRole.post(this.add_params).then((_data) => {
                if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录未失效+执行成功
                  this.d_modal_add = false;
                  this.pull_data();
                }else {
                  this.$Message.error(_data.data.Msg);
                }
              });
            }else if(_this.d_modal_type=='edit'){
              apiRole.editRole.post(this.add_params).then((_data) => {
                if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录未失效+执行成功
                  this.d_modal_add = false;
                  this.pull_data();
                }else {
                  this.$Message.error(_data.data.Msg);
                }
              });
            }

          } else {
            this.$Message.error('验证失败!');
          }
        })
      },
      no_repeat_json(arr){
        for(let i=0; i<arr.length; i++){
          for(let j=i+1; j<arr.length; j++){
            if(arr[i].MenuID == arr[j].MenuID){
              arr.splice(j,1);
              j--;
            }
          }
        }
        return arr;
      }
    },
    computed: {

    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiRole.getRoleList.data));
      this.add_params = JSON.parse(JSON.stringify(apiRole.addRole.data));
      this.pull_data();
    }
  }
</script>






